/**
 *
 * This function just returns a boolean value of the
 * IS_TEST_ENVIRONMENT variable value.
 *
 * The function is made because .env and pm2 treat the
 * type of that value differently: If we put =true in the
 * .env file, the config variable value becomes a string that says
 * 'true'. If we put =true in the pm2 ecosystem file, the
 * config variable value becomes a boolean. Hence the cast
 * to unknown and a check for both cases.
 *
 * We want the variable to default to false to minimize
 * the consequences of eventually forgetting to set the
 * variable value in a production environment and seeing
 * developer values in the client code or templates.
 */
export const isTestEnvironment = (): boolean => {
  const config = useRuntimeConfig();

  switch (config.public.isTestEnvironment as unknown) {
    case 'true':
    case true:
      return true;
    default:
      return false;
  }
};
